var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_937_45865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H56V56H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 0L27.9125 21.1167L49.175 0H56V7.23333L35 28.1167L56 48.8833V56H49L28 35.1167L7.0875 56H0V49L20.9125 28.2333L0 7.46667V0H6.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1 32.7833L56 51.3333V56L32.2875 32.7833H37.1ZM21 35.1167L21.525 39.2L4.725 56H0L21 35.1167ZM56 0V0.35L34.2125 22.2833L34.3875 17.15L51.625 0H56ZM0 0L20.9125 20.5333H15.6625L0 4.9V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0875 0V56H35.0875V0H21.0875ZM0 18.6667V37.3333H56V18.6667H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 22.5167V33.7167H56V22.5167H0ZM23.8875 0V56H32.2875V0H23.8875Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_937_45865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/united-kingdom.7590eb25059fe633936765933f1048b3.svg";
export { ForwardRef as ReactComponent };